//

module.exports = {
  baseUrl: "https://travel.wlj.tjbh.gov.cn/apis/", //正式环境
  // baseUrl: "https://tjsct-api.lintrondata.com/", //测试环境
  // baseUrl: "http://10.8.117.177:9200/", //陈力
  // baseUrl: "http://10.8.117.210:9200/", //吴美琴
  // baseUrl: "http://10.8.205.35:9200/", //童工
//   baseUrl: "https://221.239.26.100/apis/", //正式环境
  // baseUrl: "http://221.239.26.100:8081/apis/", //正式环境
  app_key:'ZHLYWLFW',//调用app函数需要的app_key,

  // 拿token
  token: '', //用户token
  // token: "9af42afd-f8dd-4dad-acf3-89b89f468182",//全局sessionStorage中存放用户TOKEN的变量名称 测试token huangwei
  audio:null,//音频
  modelState: true, //true是安卓false是ios
  loactions:[],
}
